module.exports = __webpack_public_path__ + "img/myposition_wm.07a08d93.svg";